import fetchList from '../asyncActions/fetchList';
import fetchVisualBuilding from '../asyncActions/fetchVisualBuilding';
import fetchVisualFloor from '../asyncActions/fetchVisualFloor';
import fetchVisualOverview from '../asyncActions/fetchVisualOverview';
import fetchVisualSection from '../asyncActions/fetchVisualSection';
import {setVisualMode} from '../Store/creators/common';
import {setStep} from '../Store/creators/visualData';
import {dispatch, getState} from '../Store/index';
import {StateVisualStep} from '../Store/State';
import listStateToQueryString from '../utils/listStateToQueryString';
import updateAddress from '../utils/updateAddress';
import visualStateToQueryString from '../utils/visualStateToQueryString';

const CLASS_VISUAL_LOADING = 'visual-loading';

/**
 * Применяет строку запроса к состоянию приложения.
 * 
 * @param query Строка запроса.
 */
async function applyQueryString( query: string ): Promise<void>
{
	document.body.classList.add( CLASS_VISUAL_LOADING );
	
	const normalizedQuery = (
		( query[0] === '?' )
		? query.substr( 1 )
		: query
	);
	
	const parameters: {[key: string]: string} = Object.create( null );
	
	normalizedQuery
		.split( '&' )
		.map(
			( pair ) =>
			{
				const [key, value] = pair.split( '=' );
				
				// Простой хак для массивов
				if ( key in parameters )
				{
					parameters[key] += '&' + pair;
				}
				else
				{
					parameters[key] = value;
				}
			},
		);
	
	if ( 'overview' in parameters )
	{
		await fetchList( visualToListQuery( parameters ) );
		
		await fetchVisualOverview( parameters.overview );
		
		const view = parameters.view || parameters.overview || 'front';
		
		if ( 'building' in parameters )
		{
			dispatch( setStep( StateVisualStep.BUILDING ) );
			await fetchVisualBuilding( parameters.building, view );
			
			if ( 'section' in parameters )
			{
				dispatch( setStep( StateVisualStep.SECTION ) );
				await fetchVisualSection( parameters.section, view );
				
				if ( 'floor' in parameters )
				{
					dispatch( setStep( StateVisualStep.FLOOR ) );
					await fetchVisualFloor( Number( parameters.floor ) );
				}
			}
		}
	}
	else
	{
		if (
			( normalizedQuery !== '' )
			|| ( parameters.mode === 'list' )
		)
		{
			dispatch( setVisualMode( false ) );
		}
		
		await fetchList( normalizedQuery );
	}
	
	const state = getState();
	
	if ( state.common.visualMode )
	{
		updateAddress(
			visualStateToQueryString(
				state.filter,
				state.visualData,
			),
		);
	}
	else
	{
		updateAddress(
			listStateToQueryString( state.filter ),
		);
	}
	
	document.body.classList.remove( CLASS_VISUAL_LOADING );
}

/**
 * Преобразует перечень параметров для визуального выборщика в строку запроса
 * списка.
 * 
 * @param parameters Параметры.
 */
function visualToListQuery( parameters: {[key: string]: string} ): string
{
	const parts: string[] = [];
	
	for ( const key of Object.keys( parameters ) )
	{
		switch ( key )
		{
			case 'overview':
			case 'building':
				break;
			
			case 'section':
				parts.push( 'section[]=' + parameters[key] );
				break;
			
			case 'floor':
				parts.push(
					'floorFrom=' + parameters[key],
					'floorTo=' + parameters[key],
				);
				break;
			
			default:
				parts.push( `${key}=${parameters[key]}` );
				break;
		}
	}
	
	return parts.join( '&' );
}

/**
 * Module.
 */
export {
	applyQueryString as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/applyQueryString.ts